/**
 * @typedef {Object} ConsentData
 * @property {string} consent_category - The category of consent (e.g., "marketing", "saleOfData", "analytics", "preferences").
 * @property {string[]} cookie_name_or_prefix - Array of cookie names or prefixes related to the consent category.
 */

/**
 * @typedef {Object} VisitorConsent
 * @property {boolean} marketingAllowed - Indicates if marketing cookies are allowed.
 * @property {boolean} saleOfDataAllowed - Indicates if sale of data cookies are allowed.
 * @property {boolean} analyticsAllowed - Indicates if analytics cookies are allowed.
 * @property {boolean} preferencesAllowed - Indicates if preferences cookies are allowed.
 */

class CustomerPrivacyHandler {
  constructor() {
    /** @type {ConsentData[]} */
    this.consentData = [];
    document.addEventListener('DOMContentLoaded', () => this.parseConsentData());
    document.addEventListener('visitorConsentCollected', (event) => this.processConsent(event.detail));
  }

  /**
   * Parses the consent data from the element with ID 'cookiePrivacyData'.
   */
  parseConsentData() {
    const privacyDataElement = document.getElementById('cookiePrivacyData');
    if (privacyDataElement) {
      try {
        this.consentData = JSON.parse(privacyDataElement.textContent);
        console.log('Privacy data:', this.consentData);
      } catch (error) {
        console.error('Failed to parse privacy data:', error);
      }
    }
  }

  /**
   * Processes the consent data and removes related cookies if consent is revoked.
   * @param {VisitorConsent} consent - The consent data object.
   */
  processConsent(consent) {
    if (!this.consentData || !Array.isArray(this.consentData) || this.consentData.length === 0) {
      return;
    }

    this.consentData.forEach((data) => {
      if (!consent[`${data.consent_category}Allowed`]) {
        data.cookie_name_or_prefix.forEach((cookiePrefix) => {
          this.removeCookieByPrefix(cookiePrefix);
        });
      }
    });
  }

  /**
   * Gets the cookie domain in the correct format.
   * @returns {string} - The formatted cookie domain.
   */
  getCookieDomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    return parts.length >= 2 ? `.${parts.slice(-2).join('.')}` : hostname;
  }

  /**
   * Removes cookies by their prefix.
   * @param {string} prefix - The prefix of the cookies to be removed.
   */
  removeCookieByPrefix(prefix) {
    const domain = this.getCookieDomain();
    const defaultCookieConfig = `expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`;
    prefix = prefix.trim().replaceAll('*', '');
    const cookies = document.cookie.split('; ');
    cookies.forEach((cookie) => {
      if (cookie.startsWith(prefix)) {
        const cookieName = cookie.split('=')[0];
        document.cookie = `${cookieName}=; ${defaultCookieConfig}`;
        console.log(`Cookie removed: ${cookieName}`, cookie);
      }
    });
  }
}

new CustomerPrivacyHandler();
